export const exclude: Array<string> = [
    "total commands used",
    "total messages",
    "total data updates",
    "number of commands",
    "current number of users",
    "load",
    "unload",
];